import React from 'react';

import { connect } from 'react-redux';

import { closeLogin } from '../../reducers/modals';

import styles from './login.css';

import bindAll from 'lodash.bindall';

import weChat from './wechat.svg';

import closeIcon from '../menu-bar/icon--close.svg';
var timer
class Feedback extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            fileMessage: '',
            wxLogin: 'block'
        }
        this.fileload = this.fileload.bind(this)
        this.closeLogin = this.closeLogin.bind(this)
        this.handleWxLogin = this.handleWxLogin.bind(this);
        bindAll(this, [
            'handleGetdata',
            'handlecloseWXLogin'
        ]);
    }

    fileload(e) {
        this.setState({
            fileMessage: this.refs.files.files[0].name
        })
    }
    closeLogin() {
        this.props.close()
    }
    handleGetdata() {
        let data = {
            command: "test"
        }
        const url = 'https://edu.zmrobo.com/scratch3/scratchHelp/userLogin.php';
        let formData = new FormData();
        formData.append("name", "admin");
        formData.append("password", "admin123");
        // react fetch实现跨域post请求,需要修改apach服务器的httpd.conf文件，添加Header set Access-Control-Allow-Origin *
        fetch(url, {
            method: 'POST',
            headers: {},
            body: formData,
        }).then((response) => {
            return response.text();
        }).then((json) => {
            console.log(JSON.stringify(json));
        }).catch((error) => {
            console.error(error);
        });

        // jsonp实现跨域get请求
        // $.ajax({
        //     url:"http://wx.zmrobo.com/runScratch3/test.php",  
        //     dataType:'jsonp',  
        //     data:'',  
        //     jsonp:'callback',  
        //     success:function(result) {  
        //         for(var i in result) {  
        //             console.log(i+":"+result[i]);//循环输出a:1,b:2,etc.  
        //         }  
        //     },  
        //     timeout:3000
        // });
    }
    handleWxLogin(e) {
        // 阻止事件冒泡，阻止继承父元素的事件（隐藏二维码）
        e.stopPropagation();
        let that = this
        this.setState({
            wxLogin: 'block'
        })
        let timeStamp = Date.parse(new Date());
        var obj = new WxLogin({
            self_redirect: true,
            id: "wxlogin",
            appid: "wx2c3ea9deaf8360cf",
            scope: "snsapi_login",
            redirect_uri: "https://edu.zmrobo.com/api/scratch3/saveWxCode",
            state: timeStamp,
            style: "",
            href: ""
        });


        timer = setInterval(function () {
            //const url = 'http://wx.zmrobo.com/api/Scratch3/getWxCode';
            const url = 'https://edu.zmrobo.com/getWXInfo/getWXCode.php';
            let formData = new FormData();
            formData.append("secret", "jmd");
            formData.append("state", timeStamp);
            fetch(url, {
                method: 'POST',
                headers: {},
                body: formData,
            }).then((response) => {
                return response.json();
            }).then((json) => {
                if (json.status == 1) {
                    clearInterval(timer);
                    that.getWxInfo(json.code)
                }
            }).catch((error) => {
                //console.error(error);  
            });
        }, 100);

    }
    getWxInfo(code) {
        const url = 'https://edu.zmrobo.com/getWXInfo/getWXInfo.php';
        let formData = new FormData();
        formData.append("code", code);
        fetch(url, {
            method: 'POST',
            headers: {},
            body: formData,
        }).then((response) => {
            return response.json();
        }).then((json) => {
            this.props.close()
            document.getElementsByClassName('menu-bar_loginBtn_NnVMb')[0].style.display = 'none';
            document.getElementsByClassName('menu-bar_signoutBtn_1lg8h')[0].style.display = 'inline-block';
            document.getElementsByClassName('menu-bar_logoutIcon_3npFo')[0].src = json.headImg;
        }).catch((error) => {
            console.error(error);
        });
    }
    // 点击非二维码区域隐藏二维码
    handlecloseWXLogin() {
        this.setState({
            wxLogin: 'none'
        })
        clearInterval(timer)
    }

    render() {
        const {
            isFullScreen,
            intl
        } = this.props
        return (
            <div className={styles.login} onClick={this.handlecloseWXLogin}>
                <div className={styles.fromBox}>
                    <div className={styles.fromTab}>
                        <div className={styles.fromTitle}>
                            <span>{intl.messages['general.signIn']}</span>
                            <div
                                className={styles.closeBox}
                                onClick={this.closeLogin}
                            >
                                <img
                                    className={styles.closeIcon}
                                    src={closeIcon} />
                            </div>
                        </div>
                        <div className={styles.fromContent}>
                            <form
                                className={styles.fromIcon}
                                action=""
                                method="POST"
                            >
                                <div className={styles.fromOne}>
                                    <input type="text" placeholder={intl.messages['general.username']} name="name" />
                                </div>
                                <div className={styles.fromTwo}>
                                    <input type="password" placeholder={intl.messages['general.password']} name="password" />
                                </div>
                                <div className={styles.fromBtn}>
                                    <button type="button" onClick={this.handleGetdata}>{intl.messages['general.signIn']}</button>
                                </div>
                            </form>
                            <div
                                className={styles.otherLogin}
                            >
                                <span>{intl.messages['general.otherLogins']}</span>
                                <a
                                    className={styles.wxUrl}
                                    onClick={this.handleWxLogin}
                                >
                                    <img
                                        className={styles.weChatIcon}
                                        src={weChat}
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="wxlogin" className={styles.wxlogin} style={{ display: this.state.wxLogin }}></div>
            </div>
        )
    }
}
const mapStateToProps = state => ({
    // This is the button's mode, as opposed to the actual current state
    islogin: state.scratchGui.modals.islogin
});

const mapDispatchToProps = (dispatch, props) => ({
    close: () => dispatch(closeLogin())
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Feedback);